import { render } from "./FilesPersonal.vue?vue&type=template&id=1f08a34d&scoped=true"
import script from "./FilesPersonal.vue?vue&type=script&lang=js"
export * from "./FilesPersonal.vue?vue&type=script&lang=js"

import "./FilesPersonal.vue?vue&type=style&index=0&id=1f08a34d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f08a34d"]])

export default __exports__